// 상단메뉴 데이터
export const gnbMenu = [
  {
      txt:"men",
      link:"/men",
      sub:[
        {
            txt: "all",
            link: "/men",
        },
        {
            txt: "new",
            link: "/men",
        },
        {
            txt: "best",
            link: "/men",
        },
    ],
  },
  {
      txt:"women",
      link:"/women",
      sub:[
          {
              txt: "all",
              link: "/women",
          },
          {
              txt: "new",
              link: "/women",
          },
          {
              txt: "best",
              link: "/women",
          },
      ],
  },
  {
      txt:"kids",
      link:"/kids",
      sub:[
        {
            txt: "all",
            link: "/kids",
        },
        {
            txt: "new",
            link: "/kids",
        },
        {
            txt: "best",
            link: "/kids",
        },
    ],
  },
  {
      txt:"event",
      link:"/event",
  },
  {
      txt:"sale",
      link:"/sale",
  },
//   {
//       txt:"notice",
//       link:"/notice",
//   },
];